const IMG = (id) => `https://images.unsplash.com/${id}?auto=format&fit=crop&w=900&q=75`;

const PHOTO = {
  sunsetField: IMG("photo-1648058717122-68c963580e43"),
  coast: IMG("photo-1564432689090-86bb339524a4"),
  mountainTent: IMG("photo-1683203675238-6b2dd0abe11c"),
  lakeTent: IMG("photo-1598507776352-1cb620d8aa92"),
  flowersTent: IMG("photo-1616878443139-8c68afd6b5c0"),
  campfire: IMG("photo-1699811250840-ccdc93e869f0"),
  bonfire: IMG("photo-1532458605850-e9f7a26d9f80"),
  carBoot: IMG("photo-1530065928592-fb0dc85d2f27"),
  familyCar: IMG("photo-1690533681839-01c4d82d7c86"),
  hillTents: IMG("photo-1661377453362-8b7f4427d39f"),
  festivalTents: IMG("photo-1518062304627-5532ae8c3ff2"),
};

const summerLine = () => {
  const now = new Date();
  let start = new Date(now.getFullYear(), 6, 22);
  const end = new Date(now.getFullYear(), 7, 31);
  if (now > end) start = new Date(now.getFullYear() + 1, 6, 22);
  const days = Math.ceil((start - now) / 86400000);
  return days > 0 ? { year: start.getFullYear(), value: String(days), label: "days until the summer holidays" } : { year: start.getFullYear(), value: "NOW", label: "Summer holidays are here" };
};

const TAGS = "#CampCompass #UKCamping #CampingUK #StaycationUK #TentLife";

export const IG_REELS = [
  {
    slug: "secret-prices",
    title: "Secret prices",
    angle: "Curiosity — what you can't see without an account",
    scenes: () => [
      { type: "hook", image: PHOTO.coast, kicker: "UK campers 👀", headline: "How much is this pitch?", sub: "Most campsite sites make you dig for it…", duration: 3000 },
      { type: "price", image: PHOTO.sunsetField, name: "Clifftop Touring Park", region: "Cornwall", price: "£24", caption: "…we hide it too. Unless you're in.", duration: 3200 },
      { type: "price", image: PHOTO.sunsetField, name: "Clifftop Touring Park", region: "Cornwall", price: "£24", reveal: true, caption: "Free account = every price, instantly.", duration: 3200 },
      { type: "list", tint: "#ff4500", kicker: "Sign up free to unlock", headline: "All of it.", items: ["Real prices", "Full map + directions", "Booking links", "Save favourites"], duration: 3600 },
      { type: "cta", image: PHOTO.hillTents, headline: "Stop guessing. Start camping.", size: 12, duration: 3200 },
    ],
    caption: `👀 How much is that pitch really?

CampCompass shows real prices, the full map and booking links for 22,000+ UK campsites — the moment you sign up.

It's free. 60 seconds. No card.

👉 camp-compass.uk (link in bio)

${TAGS} #CampingPrices`,
  },
  {
    slug: "only-300-free",
    title: "22,000 sites, 300 free",
    angle: "FOMO — you're only seeing a sliver",
    scenes: () => [
      { type: "counter", image: PHOTO.festivalTents, kicker: "CampCompass UK", value: "22,000+", size: 20, label: "UK campsites in one place", duration: 2800 },
      { type: "dots", headline: "Right now you can see…", lit: 3, caption: "Just 300 of them.", sub: "A new region rotates in every Monday.", duration: 3800 },
      { type: "hook", image: PHOTO.lakeTent, kicker: "The other 21,700?", headline: "Locked.", size: 19, sub: "Hidden gems, lakeside pitches, the lot.", duration: 3000 },
      { type: "list", tint: "#0a7f3f", kicker: "One free account", headline: "Opens every site.", items: ["All 22,000+ campsites", "Every region, every week", "Filters that actually work"], duration: 3400 },
      { type: "cta", image: PHOTO.mountainTent, headline: "See them all.", duration: 3000 },
    ],
    caption: `🏕️ 22,000+ UK campsites. You're seeing 300.

Without an account, CampCompass shows a rotating set of 300 — a new UK region every Monday. Sign up free and every single site unlocks.

👉 camp-compass.uk (link in bio)

${TAGS} #HiddenGems`,
  },
  {
    slug: "summer-rush",
    title: "Summer is booking up",
    angle: "Urgency — school holidays are coming",
    scenes: () => {
      const s = summerLine();
      return [
        { type: "hook", image: PHOTO.carBoot, kicker: `☀️ Summer ${s.year}`, headline: "The best pitches are going. Fast.", size: 12, duration: 3000 },
        { type: "counter", image: PHOTO.familyCar, kicker: "Heads up", value: s.value, size: 34, label: s.label, sub: "Sea views and dog-friendly sites go first.", duration: 3200 },
        { type: "list", tint: "#ff4500", kicker: "Find yours in seconds", headline: "Filter by what matters.", items: ["Dog-friendly", "Electric hook-up", "Near the beach", "Open this summer"], duration: 3800 },
        { type: "cta", image: PHOTO.sunsetField, headline: "Book before it's gone.", size: 12, sub: "Real prices + booking links for every UK site.", duration: 3200 },
      ];
    },
    caption: `☀️ The summer holidays are nearly here — and the good pitches go first.

Search 22,000+ UK campsites by dog-friendly, hook-up, near the beach and more. Real prices + booking links, free.

👉 camp-compass.uk (link in bio)

${TAGS} #SummerHolidays #FamilyCamping`,
  },
  {
    slug: "secret-pitch-map",
    title: "Secret Pitch Map",
    angle: "Discovery — hidden gems locals keep quiet",
    scenes: () => [
      { type: "hook", image: PHOTO.lakeTent, kicker: "🤫 Don't tell everyone", headline: "The campsites locals never post.", size: 12, duration: 3200 },
      { type: "map", kicker: "Secret Pitch Map", headline: "Hidden gems, pinned.", pins: [
        { label: "Lakeside · Cumbria", x: 18, y: 6 },
        { label: "Farm pitch · Wales", x: 2, y: 38 },
        { label: "Cove · Cornwall", x: 30, y: 70 },
        { label: "Forest · Peak District", x: 48, y: 30 },
      ], duration: 3800 },
      { type: "hook", image: PHOTO.flowersTent, kicker: "Quiet. Small. Stunning.", headline: "No crowds. No queues.", size: 13, sub: "Shared by real campers, not ad budgets.", duration: 3000 },
      { type: "cta", image: PHOTO.mountainTent, headline: "Unlock the map.", sub: "Free account. Every secret pitch.", duration: 3200 },
    ],
    caption: `🤫 The UK campsites locals keep quiet about.

The CampCompass Secret Pitch Map pins hidden gems: lakeside spots, tiny farm pitches, quiet coves. Sign up free to unlock it.

👉 camp-compass.uk (link in bio)

${TAGS} #SecretSpots #HiddenGemsUK`,
  },
  {
    slug: "real-campers",
    title: "Real campers",
    angle: "Community — trip photos and campfire chat",
    scenes: () => [
      { type: "hook", image: PHOTO.campfire, kicker: "🔥 Campfire chat", headline: "Camping's better with your people.", size: 12, duration: 3000 },
      { type: "chat", kicker: "Live in the Campfire chat", messages: [
        { who: "Sophie · Swansea", text: "Anyone been to Gower this month?" },
        { me: true, text: "Yes! Clifftop pitch, sunset was unreal 🌅" },
        { who: "Dan · Leeds", text: "Dog-friendly?" },
        { me: true, text: "Totally. Our spaniel loved it 🐶" },
      ], duration: 4200 },
      { type: "photos", headline: "Real trips. Real photos.", images: [PHOTO.hillTents, PHOTO.bonfire, PHOTO.lakeTent, PHOTO.coast], caption: "From campers, not adverts.", duration: 3600 },
      { type: "cta", image: PHOTO.bonfire, headline: "Pull up a chair.", sub: "Sign up free to see trip photos and read the chat.", duration: 3200 },
    ],
    caption: `🔥 Honest tips from people who've actually pitched there.

Trip photos, reviews and the Campfire chat, all on CampCompass. Sign up free to dive in.

👉 camp-compass.uk (link in bio)

${TAGS} #CampingCommunity`,
  },
];

export const getIgReel = (slug) => IG_REELS.find((r) => r.slug === slug);
export const reelDuration = (scenes) => scenes.reduce((t, s) => t + s.duration, 0);
